import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationsENUS from './locales/enUS/translations.json';
import translationsIT from './locales/it/translations.json';
import translationsDEDE from './locales/deDE/translations.json';

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false
    },
    resources: {
      'en-US': { 
        translations: translationsENUS
      },
      'it-IT': {
        translations: translationsIT
      },
      'de-DE': {
        translations: translationsDEDE
      }
    },
  });

export default i18n;